export default __webpack_public_path__ + "static/media/SanJuan.1f57a76c.png";